import PropTypes from "prop-types";
import ParticleTwo from "../particles/ParticleTwo";

const BreadcrumbContact = () => {
  return (
    <div
      className="ht__bradcaump__area__contact"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__contact">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>Contacts</h1>
              <p>
                Our dedicated support specialists are here to ensure your
                journey with The Pips is seamless and rewarding. From platform
                guidance to trading inquiries, we’re always within reach to help
                you make the most of your trading experience.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbContact.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbContact;
